import { render, staticRenderFns } from "./msDropdownItem.vue?vue&type=template&id=82320812&scoped=true"
import script from "./msDropdownItem.vue?vue&type=script&lang=js"
export * from "./msDropdownItem.vue?vue&type=script&lang=js"
import style0 from "./msDropdownItem.vue?vue&type=style&index=0&id=82320812&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82320812",
  null
  
)

export default component.exports